// extracted by css-extract-rspack-plugin
export default {"sizeFluid":"100%","typeaheadContainer":"Typeahead-module__typeaheadContainer___EkG3C","menuWrapper":"Typeahead-module__menuWrapper___CYCCG"};